import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "global-container" }

import '@/styles/global.scss'
import '@vueup/vue-quill/dist/vue-quill.snow.css'
import ImageUploader from 'quill-image-uploader'
import HeaderComponent from '@/components/home/HeaderComponent.vue'
import { firestore as db, storage, auth } from '@/main'
import { onAuthStateChanged } from 'firebase/auth'
import { onMounted, ref } from 'vue'
import { Delta, QuillEditor } from '@vueup/vue-quill'
import { doc, setDoc, updateDoc } from 'firebase/firestore'
import { getDownloadURL, ref as storageRef, uploadBytes } from 'firebase/storage'
import router from '@/router'
import { Contact, ContactUpdateRequest } from '@/types/Contact'


export default /*@__PURE__*/_defineComponent({
  __name: 'ModifyContactView',
  setup(__props) {

const panel = ref([0])
const selectedImage = ref<File|null>(null)
const showProgress = ref(false)
const contents = ref<Delta|undefined>(undefined)

const contactData = ref<ContactUpdateRequest>({
  address: '',
  contents: '',
  email: '',
  latLng: '',
  tel: ''
})

const modules = {
  name: 'Imageuploader',
  module: ImageUploader,
  options: {
    upload: (file: File) => {
      showProgress.value = true

      return new Promise((resolve, reject) => {
        uploadBytes(storageRef(storage, `contact/${file.name}`), file)
          .then((snapshot) => {
            getDownloadURL(snapshot.ref)
              .then((url) => {
                resolve(url)
              })
              .catch((e: Error) => {
                console.log(e.message)
                reject(e)
              })
              .finally(() => {
                showProgress.value = false
              })
          })
          .catch((e: Error) => {
            showProgress.value = false
            console.log(e.message)
            reject(e)
          })
      })
    }
  }
}

async function upload () {
  if (contactData.value.address === '' || contents.value === undefined || contactData.value.email === '' || contactData.value.tel === '') {
    alert('Please fill in all required fields.')
  } else {
    showProgress.value = true

    contactData.value.contents = contents.value === undefined ? '' : JSON.stringify(contents.value)

    await updateDoc(
      doc(db, 'Contact', 'Introduction'), {
        ...(contactData.value)
      }
    )
      .catch((e: Error) => {
        alert(`An error occurred while modifying post.\nPlease try again later.\n(${e.message})`)
        showProgress.value = false
      })

    if (selectedImage.value !== null) {
      const uploadRef = storageRef(storage, `contact/introduction.${selectedImage.value.name.split('.').pop()}`)

      uploadBytes(uploadRef, selectedImage.value)
        .catch((e: Error) => {
          alert(`An error occurred while uploading image.\nPlease try again later.\n(${e.message})`)
          showProgress.value = false
        })
        .then(() => {
          getDownloadURL(uploadRef)
            .then((url) => {
              updateDoc(doc(db, 'Contact', 'Introduction'), { image: url })
                .catch((e: Error) => {
                  alert(`An error occurred while saving image URL.\nPlease try again later.\n(${e.message})`)
                })
                .then(() => {
                  alert('Modified successfully.')
                  router.back()
                })
                .finally(() => {
                  showProgress.value = false
                })
            })
            .catch((e: Error) => {
              alert(`An error occurred while retrieving image URL.\nPlease try again later.\n(${e.message})`)
              showProgress.value = false
            })
        })
    } else {
      alert('Modified successfully.')
      showProgress.value = false
      router.back()
    }
  }
}

onMounted(() => {
  if (history.state.data) {
    contactData.value = { ...(history.state.data as Contact) }
    contents.value = contactData.value.contents ? new Delta(JSON.parse(contactData.value.contents)) : undefined
  } else {
    if (history.state.back !== '/contact') {
      alert('Invalid access.')
      router.back()
    }
  }
})

onAuthStateChanged(auth, (user) => {
  if (user === null) {
    window.location.reload()
  }
})

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_container, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createVNode(HeaderComponent, {
              title: 'Modify Contact',
              "trailing-icon": 'fa-solid fa-check',
              "leading-icon": 'fa-solid fa-chevron-left',
              "show-leading-btn": true,
              "show-progress": showProgress.value,
              onOnClick: upload,
              onOnLeadingBtnClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).back()))
            }, null, 8, ["show-progress"])
          ]),
          _createVNode(_component_v_expansion_panels, {
            modelValue: panel.value,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((panel).value = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_expansion_panel, {
                title: "Required Informations",
                class: "rounded-xl",
                expand: "",
                "expand-icon": 
              contactData.value.address !== '' && contents.value !== undefined &&
              contactData.value.email !== '' && contactData.value.latLng !== '' &&
              contactData.value.tel !== ''
                ? 'mdi-check'
                : 'mdi-chevron-down'
            
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_expansion_panel_text, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createVNode(_component_v_text_field, {
                          variant: "solo-filled",
                          color: "primary",
                          modelValue: contactData.value.address,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((contactData.value.address) = $event)),
                          label: "Address",
                          "prepend-inner-icon": "mdi-map-marker",
                          "clear-icon": "mdi-close",
                          clearable: "",
                          "onClick:clear": _cache[2] || (_cache[2] = ($event: any) => (contactData.value.address = ''))
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_v_text_field, {
                          variant: "solo-filled",
                          color: "primary",
                          modelValue: contactData.value.email,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((contactData.value.email) = $event)),
                          label: "E-Mail",
                          "prepend-inner-icon": "mdi-email",
                          "clear-icon": "mdi-close",
                          clearable: "",
                          "onClick:clear": _cache[4] || (_cache[4] = ($event: any) => (contactData.value.email = ''))
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_v_text_field, {
                          variant: "solo-filled",
                          color: "primary",
                          modelValue: contactData.value.tel,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((contactData.value.tel) = $event)),
                          label: "Tel",
                          "prepend-inner-icon": "mdi-phone",
                          "clear-icon": "mdi-close",
                          clearable: "",
                          "onClick:clear": _cache[6] || (_cache[6] = ($event: any) => (contactData.value.tel = ''))
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_v_file_input, {
                          modelValue: selectedImage.value,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((selectedImage).value = $event)),
                          "prepend-icon": "mdi-camera",
                          label: 'Change Image',
                          accept: "image/*",
                          variant: "solo-filled"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_unref(QuillEditor), {
                          placeholder: "Contents",
                          content: contents.value,
                          "onUpdate:content": _cache[8] || (_cache[8] = ($event: any) => ((contents).value = $event)),
                          theme: "snow",
                          toolbar: "full",
                          modules: modules
                        }, null, 8, ["content"])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["expand-icon"])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})